export default {
  items: [
    {
      header: 'NerdWallet logos',
      body:
        "Logos are the ultimate expression of any brand. Please don't modify or use ours in a way that could be misunderstood — including suggesting sponsorship or endorsement by NerdWallet, or in a way that confuses NerdWallet with another brand. If you are unsure, please reach out.",
      image:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/press-kit_logos.png',
      cta: 'Download',
      url:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/cta_file-downloads/NW_logos.zip',
      orientation: 'left',
    },
    {
      header: 'Product shots',
      body:
        'Want to feature our product in action? We’ve got you. Get high-res assets of the NerdWallet web, mobile and app experience.',
      image:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/press-kit_product-shots.png',
      cta: 'Download',
      url:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/cta_file-downloads/NW-product-shots-2020.zip',
      orientation: 'right',
    },
    {
      header: 'Office shots',
      body:
        "We love our Nerds and our space. Here you'll find a selection of photos featuring our teammates in the SF office.",
      image:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/press-kit_office-shots.png',
      cta: 'Download',
      url:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/cta_file-downloads/NW_office-shots.zip',
      orientation: 'left',
    },
    {
      header: 'Leadership headshots',
      body:
        'Check out these shots of some of our brightest Nerds from across the organization.',
      image:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/press-kit_executive-shots-2020-v2.jpg',
      cta: 'Download',
      url:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/cta_file-downloads/NW-executive-headshots-2020.zip',
      orientation: 'right',
    },
    {
      header: 'B-roll videos',
      body:
        'And we’re live! If you’d like to feature b-roll of our Nerds or our product in action, reach out to us at <a mailto="press@nerdwallet.com">press@nerdwallet.com</a>.',
      image:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/press-kit_B-roll-videos.png',
      cta: '',
      url:
        'https://www.nerdwallet.com/cdn/press-pages-2019/press-kit/cta_file-downloads/NW_b-roll.zip',
      orientation: 'left',
    },
  ],
};
